import React from "react";

const Notes = () => {
  return (
    <div className="container-fluid mt-3">
      <style>{`
        .note-card { box-shadow:0 4px 15px rgba(0,0,0,0.08); border-radius:10px; }
        .sidebar { width:220px; }
      `}</style>

      <div className="d-flex">
        {/* Sidebar */}
        <div className="sidebar p-3 bg-white">
          <h6>Notes</h6>
          <ul className="list-unstyled">
            <li>All Notes</li>
            <li>Important</li>
          </ul>
        </div>

        {/* Content */}
        <div className="flex-grow-1 p-3">
          <div className="row">
            {[1,2,3,4,5,6].map(i => (
              <div key={i} className="col-md-4 mb-3">
                <div className="card p-3 note-card">
                  <span className="badge bg-success">High</span>
                  <h6 className="mt-2">Backup Files</h6>
                  <p className="small">Take backup daily</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notes;